<template>
  <v-card
    class="integration-card"
    flat
    outlined
    height="100%"
    :class="{ 'active-card': isActive }"
  >
    <v-card-text class="d-flex flex-column align-center pa-8">
      <div class="integration-icon mb-6">
        <template v-if="!integration.icon">
          <h3 class="text-h5 mb-3 text-center">{{ integration.name }}</h3>
        </template>
        <template v-else>
          <img
            :src="integration.icon"
            :alt="integration.name"
            style="max-width: 300px; max-height: 30px; object-fit: contain"
          />
        </template>
      </div>

      <v-chip
        small
        :color="isActive ? 'success' : 'grey'"
        text-color="white"
        class="mb-4"
      >
        {{ isActive ? "Integrado" : "Não Integrado" }}
      </v-chip>

      <v-divider class="mt-4 mb-8" style="width: 100%"></v-divider>

      <v-btn
        v-if="!isActive"
        block
        color="primary"
        class="text-capitalize "
        @click="$emit('configure', integration)"
      >
        Configurar Integração
      </v-btn>
      <v-btn
        v-else
        block
        color="primary"
        outlined
        class="text-capitalize"
        @click="$emit('manage', integration)"
      >
        Gerenciar
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "IntegrationCard",
  props: {
    integration: {
      type: Object,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.integration-card {
  transition: all 0.3s ease;
  border: 2px solid #e0e0e0;
  border-radius: 12px !important;
  background: #fff;
}

.active-card {
  border-color: #88c357;
}

.integration-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 120px;
  width: 100%;
}
</style>
